import { Text } from '@newcore/ui/typography';

export const PageLoader = () => (
  <div className='flex h-full items-center justify-center'>
    <div className='flex flex-col items-center'>
      <div className='h-6 w-6 animate-spin rounded-full border-2 border-brand border-t-transparent' />
      <Text as='p' className='mt-2 text-tertiary'>
        Loading...
      </Text>
    </div>
  </div>
);
